<template>
  <div id="app">
    <keep-alive v-if="isKeepAlive">
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      layout: "div",
      isKeepAlive: true
    };
  },
  methods: {
    reload() {
      this.isKeepAlive = false;
      this.$nextTick(() => {
        this.isKeepAlive = true;
      });
    }
  },
  provide() {
    return {
      reload: this.reload
    };
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
}

#app {
  background-image: url("./assets/background.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
